import { Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { cn } from '../../lib/utils';

export function MessageInput({
  value = '',
  onChange,
  onSubmit,
  disabled,
  isDark
}) {
  return (
    <form
      onSubmit={onSubmit}
      className={cn(
        'p-4 border-t flex gap-2',
        isDark ? 'border-white/10 bg-zinc-900/50' : 'border-gray-200 bg-white'
      )}
    >
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder="Écrivez un message..."
        className={cn(
          'flex-1',
          isDark ? 'bg-zinc-800 border-white/10 text-white' : ''
        )}
        data-testid="message-input"
      />
      <Button
        type="submit"
        disabled={disabled || !value?.trim()}
        className="bg-red-500 hover:bg-red-600 text-white px-4"
        data-testid="send-message-btn"
      >
        <Send size={18} />
      </Button>
    </form>
  );
}
